<template>
  <div class="inspiration-board">
    <h2 v-if="title">{{ title }}</h2>
    <div class="board-actions">
      <button v-if="!local" @click="loadToBoard">Load to board</button>
      <button v-if="local && swatchIds.length > 0" @click="clearBoard">Clear Board</button>
      <button v-if="local && swatchIds.length > 0" @click="showPermalink = true">Save Board</button>
      <button v-if="local && swatchIds.length > 0" @click="modalShareOpen=true">Share Board</button>
      <button v-if="local && swatchIds.length > 0" @click="requestSamples">Request Samples</button>
    </div>
    <div class="board-link" v-if="showPermalink">
      This board can be viewed at the following URL. Save the URL for future reference or to share.
      <input :value="permalink" class="form-control ccm-input-text">
    </div>

    <p v-if="swatchIds.length == 0">No swatches found - <router-link to="/">browse our products</router-link></p>
    <div v-if="swatchIds.length > 0" class="card-container row">
      <swatch-card v-for="id in swatchIds"
        :id="id"
        :articles="articles"
        :swatches="swatches"
        :inspiration-board="inspirationBoard"
        @show-swatch-detail="showSwatchDetail"
        @remove-swatch-from-inspiration-board="removeSwatchFromInspirationBoard"
        @set-slideout-article="setSlideoutArticle"
        ></swatch-card>
    </div>

    <div class="modal modal-share" :class="{ 'is-active': modalShareOpen }">
      <div class="modal-card">
        <header>
          <div><a href="#close-modal" aria-label="close" @click.prevent="modalShareOpen=false">X close</a></div>
        </header>
        <section class="modal-card-body">
          <h2>Share Inspiration Board</h2>
          <p v-if="errorLoading" class="error small">Error Sending Message</p>
          <p v-if="errorValidating" class="error small">Recipient Email is Required</p>
          <div class="form-group">
            <label for="email">Recipient Email</label>
            <span class="text-muted small">Required</span>
            <input class="form-control ccm-input-text" type="email" name="email" v-model="shareEmail" autofocus />
          </div>
          <div class="form-group">
            <label for="message">Message</label>
            <textarea name="message" v-model="shareMessage" class="form-control ccm-input-textarea"></textarea>
          </div>
          <div class="form-actions">
            <button @click="sendMessage">Send</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import SwatchCard from '@/components/SwatchCard'

export default {
  name: 'InspirationBoard',
  components: {
    SwatchCard,
  },
  props: {
    articles: Object,
    swatches: Object,
    inspirationBoard: Array,
  },
  data() {
    return {
      showPermalink: false,
      modalShareOpen: false,
      shareEmail: '',
      shareMessage: '',
      errorLoading: false,
      errorValidating: false,
    }
  },
  computed: {
    local() {
      return this.$route.params.target === 'local'
    },
    swatchIds() {
      let retval = []
      if (this.local) {
        retval = this.inspirationBoard
      } else {
        this.$route.params.target.split('-').forEach((element) => {
          if (this.isInt(element)) {
            if (retval.indexOf(element) < 0) {
              retval.push(parseInt(element, 10))
            }
          }
        })
      }
      return retval
    },
    title() {
      return `${this.local ? 'Your' : 'Shared'} Inspiration Board`
    },
    permalink() {
      const ids = this.swatchIds.join('-')
      return `${window.location.protocol}//${window.location.hostname}${window.location.pathname}#/inspiration-board/${ids}`
    },
  },
  created() {
    this.$parent.$on('view-swatches', (articleId) => {
      this.$router.push(`/article=${articleId}`)
    })
  },
  methods: {
    isInt(n) {
      const nFloat = parseFloat(n)
      const nInt = parseInt(n, 10)
      return !isNaN(parseFloat(n)) && isFinite(n) && nFloat === nInt
    },
    showSwatchDetail(id) {
      this.$emit('show-swatch-detail', id) // pass it up the chain
    },
    removeSwatchFromInspirationBoard(id) {
      this.$emit('remove-swatch-from-inspiration-board', id) // pass it up the chain
    },
    loadToBoard() {
      this.$emit('load-inspiration-board', this.swatchIds) // pass it up the chain
    },
    clearBoard() {
      this.$emit('clear-inspiration-board') // pass it up the chain
      this.showPermalink = false
    },
    requestSamples() {
      let swatchIdString = ''
      this.swatchIds.forEach((swatchId) => {
        swatchIdString = `${swatchIdString}&sample_swatch_id[]=${swatchId}`
      })
      window.location.assign(`/request-samples?request=true${swatchIdString}`)
    },
    sendMessage() {
      if (!this.shareEmail.length) {
        this.errorValidating = true
      } else {
        this.errorValidating = false
        const requestData = {
          email: this.shareEmail,
          message: this.shareMessage,
          permalink: this.permalink,
        }
        const request = new XMLHttpRequest()
        request.open('POST', '/api/send-inspiration-board', true)
        request.setRequestHeader('Content-type', 'application/json')
        request.onload = () => {
          if (request.status >= 200 && request.status < 400) {
            // Success!
            const result = JSON.parse(request.responseText)
            if (result.status === 'Success') {
              this.modalShareOpen = false
            } else {
              this.errorLoading = true
            }
          } else {
            // We reached our target server, but it returned an error
            this.errorLoading = true
          }
        }
        request.onerror = () => {
          // There was a connection error of some sort
          this.errorLoading = true
        }
        request.send(JSON.stringify(requestData))
      }
    },
    setSlideoutArticle(slideoutArticleId) {
      this.$emit('set-slideout-article', slideoutArticleId)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/InspirationBoard.vue